import { render, staticRenderFns } from "./RoutesForm.vue?vue&type=template&id=f9a474c0&scoped=true&"
import script from "./RoutesForm.vue?vue&type=script&lang=js&"
export * from "./RoutesForm.vue?vue&type=script&lang=js&"
import style0 from "./RoutesForm.vue?vue&type=style&index=0&id=f9a474c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a474c0",
  null
  
)

export default component.exports